import { __dev__, __preview__ } from "../../../../utils";
import { RegionalInstanceId } from "../regional-instance-types";

/**
 * Regional instance resolution for proxy + client useSyncExternalStore.
 *
 * Production: uses the hostname to determine the regional instance.
 *
 * Development: uses the `NEXT_PUBLIC_SITE_ORIGIN_DEBUG` environment variable to determine the regional instance.
 */
export function resolveRegionalInstanceId(input: {
  hostname?: string;
}): RegionalInstanceId {
  const host = input.hostname?.toLowerCase();
  if (host === "hub.wooting.com.cn" || host?.endsWith(".hub.wooting.com.cn")) {
    return RegionalInstanceId.CN;
  }

  if (__dev__ || __preview__) {
    const debug = process.env.NEXT_PUBLIC_SITE_ORIGIN_DEBUG?.trim();
    if (debug === RegionalInstanceId.CN) {
      return RegionalInstanceId.CN;
    }
    return RegionalInstanceId.Global;
  }

  return RegionalInstanceId.Global;
}
